import styled from 'styled-components';

/** The dispatcher and website thread's bar: who, what about, and who has it. */

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const ContextLine = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.lightGray};

  a {
    color: inherit;
    text-decoration: underline;
    text-underline-offset: 2px;
  }

  /* One line on a phone, where the buttons already take half the bar and a
     wrapped line stood five rows tall over the conversation. What matters
     most comes first, so the clip only ever eats the brand and the fleet. */
  @media (max-width: 800px) {
    flex-wrap: nowrap;
    overflow: hidden;
    white-space: nowrap;

    > * {
      flex: none;
    }
  }
`;

/** Status of the delivery, in its own colour. */
export const StatusDot = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: ${({ theme }) => theme.darkGray};

  ::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ $color }) => $color};
  }
`;

export const LateChip = styled.span`
  padding: 0 6px;
  border-radius: 8px;
  background: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.white};
  font-size: 11px;
  line-height: 16px;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: none;
  margin-right: 10px;
`;

/** Who has the thread: the AI's gradient, a person, or amber while nobody does. */
export const HolderChip = styled.span<{ $ai: boolean; $waiting?: boolean }>`
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
  color: ${({ theme }) => theme.white};
  background: ${({ theme, $ai, $waiting }) =>
    $ai ? theme.aiGradient : $waiting ? theme.chipYellow : theme.darkGray};

  @media (max-width: 800px) {
    display: none;
  }
`;
